<template>
  <transition name="slide-fade">
    <div class='d-flex px-2'>
      <div class='w-100'>
        <div class="card border border-white">
          <div class='card-header text-white d-flex justify-content-between'>

            <div class='d-flex align-items-center'>
              <strong class="float-left mr-2">{{$ml.get('GROUP')}}</strong>
              <select class='new-input wpx-100 float-left' @change="changeGroupCondition" v-model='type'>
                <option selected> {{$ml.get('AND')}}</option>
                <option > {{$ml.get('OR')}} </option>
              </select>
            </div>
            
            <div class='align-self-center'>
              <button type="button" class="btn btn-secondary" @click='addSubElem("EXPR")'> <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('EXPRESSION')}}</button>
              <button type="button" class="btn btn-secondary-t" @click='addSubElem("GROUP")'> <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('GROUP')}}</button>
              <button type="button" class="btn-remove" @click='removeThis' v-if='name'> <i>&#10005;</i></button>
            </div>          

          </div>
         
          <div v-if='isUpdateMode==false' class='card-body bg-light-primary d-flex flex-column'  >
            <draggable v-model='subElem'>
              
              <div class='subElemContainer border-bottom border-white px-2' v-for='elem in subElem' v-bind:key='elem.name'>    
                
                <expression-builder-workflow  v-if='elem.type=="EXPR"' :item='item' :selectedObject="elem.selObj" :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery'></expression-builder-workflow>
                <group-builder v-if='elem.type=="GROUP"' :item='item' :selectedSavedSearch="elem.selObj" :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery'></group-builder>

              </div>
            </draggable>
          </div>
          <div v-else class='card-body bg-light-primary d-flex flex-column'  >
            <draggable v-model='updateElem'>
              
              <div class='subElemContainer border-bottom border-white px-2' v-for='elem in updateElem' v-bind:key='elem.name'>    
                
                <expression-builder-workflow  v-if='elem.type=="EXPR"' :item='item' :selectedObject="elem.selObj" :isUpdate='true' :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery' @addUpdateQuery='addQuery'></expression-builder-workflow>
                <group-builder v-if='elem.type=="GROUP"' :item='item' :selectedSavedSearch="elem.selObj" :isUpdate='true' :name='elem.name' @kill='remove' @change='updateQuery' @sendQuery='sendQuery'></group-builder>
              
              </div>
            </draggable>
          </div>
        </div>


          
        


      </div>
      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
  </transition>
</template>

<script>
  import expressionBuilderWorkflow from './expression-builder-workflow.vue'
  import draggable from 'vuedraggable'
  import swal from 'sweetalert'

  import {mapActions} from 'vuex'
  
  export default {
    name: 'group-builder',
    components: {
      expressionBuilderWorkflow,
      draggable
    },
    props: ['item', 'name','selectedSavedSearch','updateWorkflow'],
    data () {
      return {
        subElem: [],
        type: this.$ml.get('AND'),
        subType: '',
        savedSearchName:'',
        selectedObject:{
          key:'',
          val:''
        },
        itemForGroup:this.item,
        updateElem:[],
        isUpdateMode:false,
        updateQueryStringObj: {},
        addQueryElem:""
      }
    },
    watch: {
      type: function () {
        this.$emit('change', this.name, this.queryString)
      },

      item: function (newItem,OldItem) {
        // console.log('item changed in group*builder')
        
        // console.log("newItem")
        // console.log(newItem)
        // console.log("OldItem")
        // console.log(OldItem)
        if(OldItem!==undefined){
          this.subElem = []
        }
        
      },
      selectedSavedSearch:function(selectedSavedSearch){
        // console.log("selectedSavedSearch in group builder")
        // console.log(selectedSavedSearch)
        this.subElem = []
        this.savedSearchName = ''
        if(this.selectedSavedSearch.searchData){
          this.savedSearchName = this.selectedSavedSearch.savedSearchName
          var sss = JSON.parse(this.selectedSavedSearch.searchData)
          this.searchInputLoop(sss.searchInput)
        }
        
      }
      
    },
    methods: {
      ...mapActions(['deleteSearch','getSavedSearches']),
      addSubElem: function (elemType,savedQuery,selObj) {
      
        var sQuery=''
        var rName = this.randomName()
        if(savedQuery){
          sQuery=savedQuery
        }
        
        var subElemx = {
          type: elemType,
          name: rName,
          query: sQuery,
          selObj:''
        }
        
        if(selObj){
          subElemx['selObj'] = selObj
        }
    
        if(this.isUpdateMode==true){
          this.updateElem.push(subElemx)
        }
        else{
          this.subElem.push(subElemx)
        }
        
        // if(savedQuery){
        //   this.updateQuery(rName,savedQuery)
        // }
       
      },
      addQuery(data){
        this.addQueryElem = data
      },
      updateQueryString(){
        
        var string = ' "and" : ['

        var onlyString = ''

        if (this.type === 'OR' || this.type === 'VEYA') {
          string = ' "or" : ['
        }

        if(this.isUpdateMode==true){
          var size = this.updateElem.length
        }
        else{
          var size = this.subElem.length
        }
    
        for (var i = 0; i < size; i++) {
          
          try {
              if(this.isUpdateMode==true){

                var subElem = this.updateElem[i].selObj

                if(subElem.key == "<"){
                  var operator = '<'
                }
                else if(subElem.key == "=<"){
                  var operator = '=<'
                }
                else if(subElem.key == ">="){
                  var operator = '>='
                }
                else if(subElem.key == ">"){
                  var operator = '>'
                }
                else if(subElem.key == "in"){
                  var operator = 'in'
                }
                else if(subElem.key == "exists"){
                  var operator = 'exists'
                }
                else{
                  var operator = "=="
                }
            
              }

          } catch (e) {

          }

          if(this.isUpdateMode==false){
            
          }
          else{
            if(size > 1){
              // if(typeof Object.values(subElem)[0] == 'object' && (subElem.hasOwnProperty('title') || subElem.hasOwnProperty('notes')) ){
              //   string += '{"' + operator + '": [ ' + value + ',{ "var":"' + key + '"}]}'
              // }
              // else{
              //   string += '{"' + operator + '": [{ "var":"' + subElem.val[0].var + '"},' + '"' + subElem.val[1] + '"' + ']}'
              // }
              if(subElem.key==='in'){
                string += '{"' + operator + '": [ "' + subElem.val[0] + '",{ "var":"' + subElem.val[1].var + '"}]}'
              }
              else{
                if(subElem.val[1].var!=undefined && subElem.key==='=='){
                  string += '{"' + operator + '": [{ "var":"' + subElem.val[1].var + '"},' + '"' + subElem.val[0] + '"' + ']}'
                }
                else{
                  if(subElem.val[0].var==undefined){
                    string += '{"' + operator + '": [{ "var":"' + subElem.val[0] + '"},' + '"' + subElem.val[1] + '"' + ']}'
                  }
                  else{
                    string += '{"' + operator + '": [{ "var":"' + subElem.val[0].var + '"},' + '"' + subElem.val[1] + '"' + ']}'
                  }
                }
              }

            }else{    
              if(subElem.key==='in'){
                onlyString = '{"' + operator + '": [ "' + subElem.val[0] + '",{ "var":"' + subElem.val[1].var + '"}]}'
              }
              else{
                if(subElem.val[1].var!=undefined && subElem.key==='=='){
                  onlyString = '{"' + operator + '": [{ "var":"' + subElem.val[1].var + '"},' + '"' + subElem.val[0] + '"' + ']}'
                }
                else{
                  if(subElem.val[0].var==undefined){
                    onlyString = '{"' + operator + '": [{ "var":"' + subElem.val[0] + '"},' + '"' + subElem.val[1] + '"' + ']}'
                  }
                  else{
                    onlyString = '{"' + operator + '": [{ "var":"' + subElem.val[0].var + '"},' + '"' + subElem.val[1] + '"' + ']}'
                  }
                }
              }
            }
          }
          
          if (i < size - 1) {
            string += ','
          }
          
        }

        string += ']'

        if (!this.name) {
          string = '{' + string + '}'
        }

        let stringChecker

        if(size > 1){
          stringChecker = string
        }else{
          stringChecker = onlyString
        }
        this.updateQueryStringObj = stringChecker
      },

      updateQuery: function (name, string) {
  
        if(this.isUpdateMode==false){
          for (var i = 0; i < this.subElem.length; i++) {
            if (this.subElem[i].name === name) {
              this.subElem[i].query = string
              this.$emit('change', this.name, this.queryString)
              break
            }
          }
        }
        else{
          for (var i = 0; i < this.updateElem.length; i++) {
            if (this.updateElem[i].name === name) {

              if(this.updateElem[i].selObj == ""){
                var subElement = {}
                subElement['key']=""
                subElement['val']= []
                
                var obj = JSON.parse('{' + this.addQueryElem + '}')
                subElement['val'][0] = { var : Object.keys(obj)[0] }

                if(typeof Object.values(obj)[0] == "object"){
                
                  if(Object.values(obj)[0].hasOwnProperty('$regex')){
                 
                    subElement['key'] = "in"
                    subElement['val'][1] = Object.values(obj)[0].$regex
                  }
                  else if(Object.values(obj)[0].hasOwnProperty('$gt')){
                    subElement['key'] = ">"
                    subElement['val'][1] = Object.values(obj)[0].$gt
                  }
                  else if(Object.values(obj)[0].hasOwnProperty('$gte')){
                    subElement['key'] = ">="
                    subElement['val'][1] = Object.values(obj)[0].$gte
                  }
                  else if(Object.values(obj)[0].hasOwnProperty('$lt')){
                    subElement['key'] = "<"
                    subElement['val'][1] = Object.values(obj)[0].$lt
                  }
                  else if(Object.values(obj)[0].hasOwnProperty('$lte')){
                    subElement['key'] = "=<"
                    subElement['val'][1] = Object.values(obj)[0].$lte
                  }
                  else if(Object.values(obj)[0].hasOwnProperty('$exists')){
                    subElement['key'] = "exists"
                    subElement['val'][1] = true
                  }
                }
                else{
                  subElement['val'][1] = Object.values(obj)[0]
                }
                this.updateElem[i].selObj=subElement
              }
              else{
                if(this.updateElem[i].selObj.key === 'in'){
                  console.log("if girildi");
                  var obj = JSON.parse('{' + string + '}')

                  this.updateElem[i].selObj.val[1].var = Object.keys(obj)[0]

                  if(typeof Object.values(obj)[0] == "object"){
                    if(Object.values(obj)[0].hasOwnProperty('$regex')){
                      this.updateElem[i].selObj.key = "in"
                      this.updateElem[i].selObj.val[0] = Object.values(obj)[0].$regex
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$gt')){
                      this.updateElem[i].selObj.key = ">"
                      this.updateElem[i].selObj.val[0] = Object.values(obj)[0].$gt
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$gte')){
                      this.updateElem[i].selObj.key = ">="
                      this.updateElem[i].selObj.val[0] = Object.values(obj)[0].$gte
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$lt')){
                      this.updateElem[i].selObj.key = "<"
                      this.updateElem[i].selObj.val[0] = Object.values(obj)[0].$lt
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$lte')){
                      this.updateElem[i].selObj.key = "=<"
                      this.updateElem[i].selObj.val[0] = Object.values(obj)[0].$lte
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$exists')){
                      this.updateElem[i].selObj.key = "exists"
                      this.updateElem[i].selObj.val[0] = true
                    }
                  }
                  else{
                    this.updateElem[i].selObj.key = "=="
                    this.updateElem[i].selObj.val[0] = Object.values(obj)[0]
                  }


                }
                else{
                  var obj = JSON.parse('{' + string + '}')

                  if(this.updateElem[i].selObj.val[0].var !== undefined){
                    this.updateElem[i].selObj.val[0].var = Object.keys(obj)[0]
                  }
                  else{
                    this.updateElem[i].selObj.val[0]= Object.keys(obj)[0]
                  }
                  
                  if(typeof Object.values(obj)[0] == "object"){
                    
                    if(Object.values(obj)[0].hasOwnProperty('$regex')){
                      this.updateElem[i].selObj.key = "in"
                      this.updateElem[i].selObj.val[1] = Object.values(obj)[0].$regex
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$gt')){
                      this.updateElem[i].selObj.key = ">"
                      this.updateElem[i].selObj.val[1] = Object.values(obj)[0].$gt
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$gte')){
                      this.updateElem[i].selObj.key = ">="
                      this.updateElem[i].selObj.val[1] = Object.values(obj)[0].$gte
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$lt')){
                      this.updateElem[i].selObj.key = "<"
                      this.updateElem[i].selObj.val[1] = Object.values(obj)[0].$lt
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$lte')){
                      this.updateElem[i].selObj.key = "=<"
                      this.updateElem[i].selObj.val[1] = Object.values(obj)[0].$lte
                    }
                    else if(Object.values(obj)[0].hasOwnProperty('$exists')){
                      this.updateElem[i].selObj.key = "exists"
                      this.updateElem[i].selObj.val[1] = true
                    }
                  }
                  else{
                    this.updateElem[i].selObj.key = "=="
                    this.updateElem[i].selObj.val[1] = Object.values(obj)[0]
                  }
                }
              }

              this.updateQueryString()
              this.$emit('change', this.name, this.updateQueryStringObj)
              break
            }
          }
        }
      },

      remove: function (name) {
        //console.log('Request kill for ' + name)
        for (var i = 0; i < this.subElem.length; i++) {
          if (this.subElem[i].name === name) {
            this.subElem.splice(i, 1)
            break
          }
        }
        if(this.isUpdateMode==true){
          for (var i = 0; i < this.updateElem.length; i++) {
            if (this.updateElem[i].name === name) {
              this.updateElem.splice(i, 1)
              this.updateQueryString()
              break
            }
          }
        }
      },

      removeThis: function () {
        this.$emit('kill', this.name)
      },

      sendQuery: function () {
        if(this.isUpdateMode==false){
          this.$emit('sendQuery', this.queryString)
        }
        else{;
          this.$emit('sendQuery', this.updateQueryStringObj)
        }
        
      },

      saveQuery:function(){
        this.$emit('saveQuery', this.queryString , this.savedSearchName)
      },

      randomName: function () {
        var hash = Math.random().toString(36).substr(2)
        return hash
      },
      getGroupInfo(item){
        var group = {}
        group['type'] = Object.keys(item)[0]
        if(group.type=='$or'){
          group['label'] = this.$ml.get('OR')
        }else if(group.type=='$and'){
          group['label'] = this.$ml.get('AND')
        }
        return group
      },
      searchInputLoop(searchInput){
       
        if(searchInput){
          searchInput = JSON.parse(searchInput)
          var group = this.getGroupInfo(searchInput)
          this.type = group.label
          var query =''
          for(var i in searchInput[group.type]){
            var item = searchInput[group.type][i]

            if(Object.keys(item)[0]=='$and'||Object.keys(item)[0]=='$or'){
              var selObj = {}
              var searchData = {}
              searchData['searchInput'] = JSON.stringify(item)
              selObj['searchData'] = JSON.stringify(searchData)
              this.addSubElem("GROUP",'"'+Object.keys(item)[0]+'":"'+JSON.stringify(item[Object.keys(item)[0]])+'"',selObj)
            }else{
              var selObj = {}
              selObj['key']=Object.keys(item)[0]
              selObj['val']=item[Object.keys(item)[0]]
              this.addSubElem('EXPR','"'+Object.keys(item)[0]+'":"'+item[Object.keys(item)[0]]+'"',selObj)
            }
          }
        }
      },
      getWorkflowGroupInfo(item){
        var group = {}
        group['type'] = Object.keys(item)[0]

        if(group.type=='and'){
          group['label'] = this.$ml.get('AND')
          
        }else{
          group['label'] = this.$ml.get('OR')
        }
        return group
      },
      workflowPreconditionInput(input,conditionType){
        this.isUpdateMode=true
        if(input){
          var group = this.getWorkflowGroupInfo(input)
          if(conditionType=="single"){
            var item = input
            var selObj = {}
            selObj['key']=Object.keys(item)[0]
            selObj['val']=item[Object.keys(item)[0]]
            this.addSubElem('EXPR','"'+Object.keys(item)[0]+'":"'+item[Object.keys(item)[0]]+'"',selObj)
          }
          else{
          
            for(var i in input[group.type]){
              var item = input[group.type][i]
            
              if(Object.keys(item)[0]=='and'|| Object.keys(item)[0]=='or'){
                
                this.type = Object.keys(item)[0]
                var selObj = {}
                var conditionData = {}
                conditionData['searchInput'] = JSON.stringify(item)
                selObj['searchData'] = JSON.stringify(conditionData)
                this.addSubElem("GROUP",'"'+Object.keys(item)[0]+'":"'+JSON.stringify(item[Object.keys(item)[0]])+'"',selObj)
              }else{
                if(Object.keys(input)[0] == "and"){
                  this.type = this.$ml.get('AND')
                }
                else{
                  this.type = this.$ml.get('OR')
                }
                var selObj = {}
                selObj['key']=Object.keys(item)[0]
                selObj['val']=item[Object.keys(item)[0]]
                this.addSubElem('EXPR','"'+Object.keys(item)[0]+'":"'+item[Object.keys(item)[0]]+'"',selObj)
              }
            }
          }
          
        }
      },
      changeGroupCondition(){
        if(this.isUpdateMode == true){
          this.updateQueryString()
        }
      },
      deleteSearchF(savedSearchId){
        // console.log('savedSearchId : '+ savedSearchId)
        swal({
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('DELETE_SEARCH_WARN'),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            
            var form={}
            form['savedSearchId'] = savedSearchId
            this.deleteSearch(form).then((res) => {

                if(res.data.status.code){

                  this.getSavedSearches()
                  this.$emit('searchDeleted')
                  this.$notify({ 
                      group: 'foo',
                      type: 'success', 
                      title: this.$ml.get('SUCCESSFUL'),
                      text: res.data.status.desc
                  })
                  
                }
            }).catch(e => {
                console.log(e)
            })
          }
        });
        
      },
      editSearchF(savedSearchId){
        // console.log('edit search')
        swal({
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('EDIT_SEARCH_WARN'),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willEdit) => {
          if (willEdit) {
            this.$emit('editQuery', this.queryString , this.savedSearchName, savedSearchId) 
          }
        });
        
      },
      setSearchName(){
        this.selectedSavedSearch.savedSearchName = this.savedSearchName
      }
    },
    mounted(){
      if(this.selectedSavedSearch.searchData){
        this.savedSearchName = this.selectedSavedSearch.savedSearchName
        var sss = JSON.parse(this.selectedSavedSearch.searchData)
        this.searchInputLoop(sss.searchInput)
      }
      if(this.updateWorkflow.workflowPrecondition){
        if((this.updateWorkflow.workflowPrecondition.split('var').length-1) < 2){
          var condition = JSON.parse(this.updateWorkflow.workflowPrecondition)
          this.workflowPreconditionInput(condition,'single')
        }
        else{
          var condition = JSON.parse(this.updateWorkflow.workflowPrecondition)
          this.workflowPreconditionInput(condition,'multiple')
        }
        
      } 
    },

    computed: {
      queryString: function () {
        // console.log('Querytring girdimi')
        var string = ' "and" : ['

        var onlyString = ''

        if (this.type === 'OR' || this.type === 'VEYA') {
          string = ' "or" : ['
        }

        if(this.isUpdateMode==true){
          var size = this.updateElem.length
        }
        else{
          // console.log(this.subElem);
          var size = this.subElem.length
        }
    
        for (var i = 0; i < size; i++) {
          
          try {
              if(this.isUpdateMode==true){
                 // console.log(this.subElem[i]);
                var subElem = this.updateElem[i].selObj
                // console.log(subElem);
              }
              else{
                // console.log(this.subElem[i]);
                var subElem = JSON.parse('{' + this.subElem[i].query + '}')
              }
              
              if(typeof Object.values(subElem)[0] == 'string'){
                var operator = '==' 
                var key = Object.keys(subElem)[0]
                var value = '"' + Object.values(subElem)[0] + '"'

              }else if(typeof Object.values(subElem)[0] == 'number'){
                var operator = '=='
                var key = Object.keys(subElem)[0]
                var value = '"' + Object.values(subElem)[0] + '"'
            
              }else if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$options') && Object.values(subElem)[0]['$options']==='im' ){
                var operator = 'in' 
                var key = Object.keys(subElem)[0]
                var value = '"' + Object.values(subElem)[0].$regex + '"'

              }else if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$in') ){
                var operator = '==' 
                var key = Object.keys(subElem)[0]
                var value = JSON.stringify(Object.values(Object.values(subElem)[0])[0])

              }else if(typeof Object.values(subElem)[0] == 'boolean'){
                var operator = '=='
                var key = Object.keys(subElem)[0]
                var value = Object.values(subElem)[0]
                // var value = '"' + Object.values(subElem)[0] + '"'
              }else{
                // <
                var small = Object.values(subElem)[0]
                var key = Object.keys(subElem)[0]
                var value = JSON.stringify(Object.values(Object.values(subElem)[0])[0])
                var smallOperator = Object.keys(small)[0]
      
                
              
                if(smallOperator == '$lt'){
                  var operator = '<'
                }

                // >
                var big = Object.values(subElem)[0]

                var key = Object.keys(subElem)[0]

                var value = JSON.stringify(Object.values(Object.values(subElem)[0])[0])

                var bigOperator = Object.keys(big)[0]
                // console.log('big')
                // console.log(bigOperator)
                if(bigOperator == '$gt'){
                  var operator = '>'
                }

                // =<
                var smallOrEqual = Object.values(subElem)[0]

                var key = Object.keys(subElem)[0]

                var value = JSON.stringify(Object.values(Object.values(subElem)[0])[0])

                var smallOrEqualOperator = Object.keys(smallOrEqual)[0]
                // console.log('smallOrEqual')
                // console.log(smallOrEqualOperator)
                if(smallOrEqualOperator == '$lte'){
                  var operator = '<='
                }

                // >=
                var bigOrEqual = Object.values(subElem)[0]

                var key = Object.keys(subElem)[0]

                var value = JSON.stringify(Object.values(Object.values(subElem)[0])[0])


                var bigOrEqualOperator = Object.keys(bigOrEqual)[0]
                // console.log('bigOrEqual')
                // console.log(bigOrEqualOperator)
                if(bigOrEqualOperator == '$gte'){
                  var operator = '>='
                }

              }
              
          } catch (e) {

          }

          if(this.isUpdateMode==false){
            if(size > 1){
              // console.log('Büyüktür birden')
            
              if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$options') && Object.values(subElem)[0]['$options']==='im'  ){
                string += '{"' + operator + '": [ ' + value + ',{ "var":"' + key + '"}]}'
              }
              else{
                string += '{"' + operator + '": [{ "var":"' + key + '"},' + value + ']}'
              }
              // string += '{"' + operator + '": [{ "var":"' + key + '"},' + value + ']}'
            }else{
              // console.log('Küçüktür birden')
              if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$options') && Object.values(subElem)[0]['$options']==='im'  ){
                onlyString = '{"' + operator + '": [ ' + value + ',{ "var":"' + key + '"}]}'
              }
              else{
                onlyString = '{"' + operator + '": [{ "var":"' + key + '"},' + value + ']}'
              }
            }
          }
          else{
            if(size > 1){
              // console.log('Büyüktür birden')
              if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$options') && Object.values(subElem)[0]['$options']==='im'  ){
                string += '{"' + operator + '": [ ' + value + ',{ "var":"' + key + '"}]}'
              }
              else{
                string += '{"' + operator + '": [{ "var":"' + subElem.val[0].var + '"},' + '"' + subElem.val[1] + '"' + ']}'
              }
              // string += '{"' + operator + '": [{ "var":"' + key + '"},' + value + ']}'
            }else{
              // console.log('Küçüktür birden')
              if(typeof Object.values(subElem)[0] == 'object' && Object.values(subElem)[0].hasOwnProperty('$options') && Object.values(subElem)[0]['$options']==='im'  ){
                onlyString = '{"' + operator + '": [ ' + value + ',{ "var":"' + key + '"}]}'
              }
              else{
                onlyString = '{"' + operator + '": [{ "var":"' + subElem.val[0].var + '"},' + '"' + subElem.val[1] + '"' + ']}'
              }
            }
          }
          
          if (i < size - 1) {
            string += ','
          }
          
        }

        string += ']'

        if (!this.name) {
          string = '{' + string + '}'
        }

        let stringChecker

        if(size > 1){
          stringChecker = string
        }else{
          stringChecker = onlyString
        }
        return stringChecker
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wpx-100{
    width: 100px;
  }
  .card {
    width:100%;
    margin-bottom: 5px;
  }

  .card-header {
    padding: 2px;
    padding-left: 8px;
    padding-right: 5px;
    background-color: #3767a0;
    font-size: 18px;
    height: 40px;
  }

  .card-footer {
    padding: 5px;
    font-size: 12px;
  }

  .card-body {
    padding: 0;
    padding-top: 5px;
    background-color: #e6e7e8;
  }

  .btn-secondary {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 16px;
    background-color: #3c89d8;
  }
  .btn-secondary-t {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 16px;
    background-color:transparent;
    color:white;
  }

  .bg-light-primary{
      background-color: #E8F4FD;
  }
  .blank-div {
    width: 24px;
  }

  .btn-delete {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
  .btn-danger {
    padding-top: 0;
    padding-left: 1px;
    padding-right: 1px;
    padding-bottom: 2px;
  }

  .btn-remove{
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
  .btn-remove i{
    border-radius: 4px;
    padding: 0px 3px;
    font-weight: 400;
    font-style: normal;
    background-color: #f44336;
    color: #FFF;
  }

  .btn-success {
    padding-left: 20px;
    padding-right: 20px;
  }

  img {
    width: 18px;
    height: 18px;
  }

  select {
    padding: 4px;
    padding-right: 28px;
    font-size: 15px;
    height: 30px;
  }

  .slide-fade-enter-active {
    transition: all .15s ease;
  }

  .slide-fade-enter {
    transform: translateY(10px);
    opacity: 0;
  }

  @media screen and (min-width: 1366px) {
    .btn-secondary {
      font-size: 21px;
    }
    select{
      height:42px;
    }
    .card-header{
      font-size: 21px;
      height: 50px;
    }
  }
</style>
